module.exports = __webpack_public_path__ + "img/header.b774727f.png";